import { render, staticRenderFns } from "./watchAccount.vue?vue&type=template&id=3772dac6&scoped=true"
import script from "./watchAccount.vue?vue&type=script&lang=js"
export * from "./watchAccount.vue?vue&type=script&lang=js"
import style0 from "./watchAccount.vue?vue&type=style&index=0&id=3772dac6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3772dac6",
  null
  
)

export default component.exports